import { useAmountMemoryStore } from "~/stores/cansino/amountMemory";

/*
 * @Author: Merlin
 * @Date: 2024-01-30 10:46:04
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-01 13:08:03
 * @Description: 
 */
interface BetForm {
    amount: number;
    frontID: number;
    isFast: boolean;
    buyBonus: boolean;
    isBonusBet: boolean;
}

// 👇 普通摇奖
// 4249["games.furypharaoh.bet",{"amount":"100.00000000","isFast":false,"frontID":1711433095251}]	
// 输：4349[{"response":{"roll_number":"H4,B,H3,H4,N1,N1,H2,B,N4","winAmount":0,"bonusWin":false}}]	
// 赢：43100[{"response":{"roll_number":"N3,N4,N4,N3,N4,H1,B,N4,N4","winAmount":10,"bonusWin":false}}] // bonusWin 时而为真

// 👇 购买一个特奖
// 4250["games.furypharaoh.bet",{"amount":100,"isFast":false,"buyBonus":true}]	
// 4350[{"response":{"amount":8000,"confirmed":false,"currency":"funfury","timestamp":"2024-03-26T06:08:42.576Z","user":"6566c714572c629a6d05e562","isBonusGame":true,"hash":"fe3052731be0766bcf8fd9321c1153a8510016f01720ad8e6e52f1431f1f8336","bonusGameAmount":100,"userInfo":{"isSystemAccount":false,"type":"default"},"isBuyBonus":true,"_id":"6602666a0d5f34acae33275b"}}]	
var aa = { 
    "amount":8000,
    "confirmed":false,
    "currency":"funfury",
    "timestamp":"2024-03-26T06:08:42.576Z",
    "user":"6566c714572c629a6d05e562",
    "isBonusGame": true,
    // "isBuyBonus": true, // 花钱买的特奖将有此标记
    "hash":"fe3052731be0766bcf8fd9321c1153a8510016f01720ad8e6e52f1431f1f8336",
    "bonusGameAmount":100,
    "userInfo":{"isSystemAccount":false,"type":"default"},
    "isBuyBonus":true,"_id":"6602666a0d5f34acae33275b"
};

// 👇 摇奖（特奖）+ 返回结果
// 4248["games.furypharaoh.bet",{"amount":"100.00000000","isFast":false,"isBonusBet":true,"frontID":1711432794189}]	
// 4348[{"response":{"roll_number":"499","winAmount":49900}}]
// --
// 4251["games.furypharaoh.bet",{"amount":"100.00000000","isFast":false,"isBonusBet":true,"frontID":1711433356980}]	
// 4351[{"response":{"roll_number":"067","winAmount":6700}}]


export const usePharaohSocket = (rootPath = 'games') => {
    // ↓ 普通下注
    const EMIT_PHARAOH_BET = async (data: BetForm) => {
        // data.buyBonus: true, 购买特奖
        // data.isBonusBet: true, 开始摇特奖
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        if (0 && import.meta.dev){
            const oTextRes = getTestValue(data); // 测试 
            console.log("oTextRes\n", deepCopy(oTextRes));
            return oTextRes;
        }
        const res = await asyncEmit(
            `${rootPath}.corgipharaoh.bet`, 
            {...data},
        );
        if ((res as any)?.response){
            return (res as any).response;
        }
        return res;
    };
    return {
        EMIT_PHARAOH_BET,
    };
};

// ↓ 取得测试值 
function getTestValue(data: BetForm){
    if (data.buyBonus){
        return {
            "amount":8000,
            "confirmed":false,
            "currency":"funfury",
            "timestamp":"2024-03-26T06:08:42.576Z",
            "user":"6566c714572c629a6d05e562",
            "isBonusGame":true,
            "hash":"fe3052731be0766bcf8fd9321c1153a8510016f01720ad8e6e52f1431f1f8336",
            "bonusGameAmount":100,
            "userInfo":{"isSystemAccount":false, "type": "default"},
            "isBuyBonus":true,
            "_id":"6602666a0d5f34acae33275b",
        };
    }else if (data.isBonusBet){
        const roll_number = getNumber();
        return {
            roll_number, // "499",
            "winAmount": roll_number == '000' ? 0 : 900.888,
        };
    }else{
        const roll_number = getData();
        const oResult = {
            roll_number, // "H4,B,H3,H4,N1,N1,H2,B,N4",
            ...getWinResult(roll_number),
            // "winAmount": 123,
            // "bonusWin": false, // ←时而为真 
        };
        return oResult;
    }
}

function getNumber(){
    const random = Math.random();
    if (random >= 0.6) {
        console.log(`random = ${random}`);
        return '000';
    }
    const sNumber = `
        ${~~(10*Math.random())}
        ${~~(10*Math.random())}
        ${~~(10*Math.random())}
    `.replace(/\s+/g, '');
    return sNumber;
}

function getData(){
    if (Math.random() >= 0.5) { 
        // ↓ 赢到 bonous 的结果  
        return 'B,H1,H2,B,H1,H3,B,H1,H4';
    }
    // ↓ 一共 9 种可能性 
    const all_item = ['H1', 'H2', 'H3', 'H4', 'N1', 'N2', 'N3', 'N4', 'B'];
    const winMark = Math.random() >= 0.3;
    const iLong = (
        winMark
        ? 1 : 2
        // ? 2 : all_item.length - 1
    );
    const sResult = Array(9).fill(0).map(cur => {
        const index = getRandomInt(0, iLong);
        console.log("index:", index, all_item[index]);
        return all_item[index];
    }).join(',');
    return sResult;
}

function getWinResult(roll_number) {
    // ↓ 5个中奖形式 
    const aFivePrize = Object.freeze({
        top: [0, 3, 6],
        mid: [1, 4, 7],
        bot: [2, 5, 8],
        Dtop: [0, 4, 8],
        Dbot: [2, 4, 6],
    });
    const a01 = roll_number.split(",");
    let winAmount = 1000.234; // 伪造赢钱金额 
    let bonusWin = false;
    for (const sPrizeName in aFivePrize) {
        const aCur = aFivePrize[sPrizeName];
        const h = a01[aCur[0]];
        const l = a01[aCur[1]];
        const f = a01[aCur[2]];
        if (h === l && h === f) {
            if (h == "B"){
                bonusWin = true;
            }else{
                winAmount++;
            }
        }
    }
    return { winAmount, bonusWin };
}


const arr = [
    // {"roll_number": "N1,N1,H4,  N1,N3,B,  N1,N1,N1", "winAmount": 0, "bonusWin": false}, 
    {"roll_number": "N4,H2,N4,  N4,N4,H1,  N4,N2,N2", "winAmount": 0, "bonusWin": false}, 
    {"roll_number": "N4,N4,H4,  N4,N4,N4,  N4,H3,N3", "winAmount": 0, "bonusWin": false}, 
    {"roll_number": "H3,H3,H1,  B,H2,H4,  N3,N3,N3", "winAmount": 0, "bonusWin": false}, 
    // {"roll_number": "N1,N1,H4,  N4,H1,N4,  N3,N4,H2", "winAmount": 0, "bonusWin": false}, 
    // {"roll_number": "N1,N1,N1,  N1,H2,H4,  N1,N1,N1", "winAmount": 40, "bonusWin": false}, 
    {"roll_number": "H2,N4,N4,  H2,N1,H2,  B,N2,N2", "winAmount": 0, "bonusWin": false}, 
    {"roll_number": "N3,N3,N4,  N3,N2,N2,  N3,N1,N1", "winAmount": 0, "bonusWin": false}, 
    {"roll_number": "N3,N3,N4,  N4,H1,N4,  N4,N4,N4", "winAmount": 10, "bonusWin": false}, 
    {"roll_number": "N3,N3,N4,  N3,N2,N2,  N3,N1,N1", "winAmount": 0, "bonusWin": false}, 
    {"roll_number": "N3,N3,N4,  N4,H1,N4,  N4,N4,N4", "winAmount": 10, "bonusWin": false}, 
    {"roll_number": "N2,N2,N2,  N1,N1,N1,  N4,N4,N4", "winAmount": 0, "bonusWin": false}, 
    {"roll_number": "H3,H3,B,  H3,N3,H3,  H3,H3,N3", "winAmount": 80, "bonusWin": false}, 
    {"roll_number": "N2,N2,N2,  N1,N1,N1,  N4,N4,N4", "winAmount": 0, "bonusWin": false}, 
    {"roll_number": "H3,H3,B,  H3,N3,H3,  H3,H3,N3", "winAmount": 80, "bonusWin": false}, 
].map(cur => {
    cur.roll_number = cur.roll_number.replace(/\s/g, '');
    return cur;
});

